import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Holiday as H, holiday } from "@planzone/dto";
import { TextInput } from "@common/textInput";
import { Holiday } from "./holiday";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ formData, edit }: Props) {
  const { t } = useTranslation();
  const [calendarName, setCalendarName] = useState(formData.name);
  const [holidays, setHolidays] = useState<H[]>([]);

  const handleCalendarNameChange = (name: string) => {
    setCalendarName(name);
    edit({ ...formData, name, holidays });
  };

  const handleHolidayChange = (index: number, holiday: H) => {
    const updatedHolidays = [...holidays];

    updatedHolidays[index] = holiday;
    setHolidays(updatedHolidays);
    edit({ ...formData, name: calendarName, holidays: updatedHolidays });
  };

  const handleAddHoliday = () => setHolidays([...holidays, { ...holiday }]);

  const handleRemoveHoliday = (index: number) => {
    const updatedHolidays = holidays.filter((_, i) => i !== index);

    setHolidays(updatedHolidays);
    edit({ ...formData, name: calendarName, holidays: updatedHolidays });
  };

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("calendarHolidays.creation.nameTitle")}
        </h2>
        <TextInput
          placeholder={t("calendarHolidays.creation.namePlaceholder")}
          value={calendarName}
          input={(name) => handleCalendarNameChange(name)}
          autoFocus
        />
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("calendarHolidays.creation.holidaysTitle")}
        </h2>
        {holidays.map((holiday, index) => (
          <Holiday
            key={index}
            holiday={holiday}
            onChange={(updatedHoliday) =>
              handleHolidayChange(index, updatedHoliday)
            }
            onRemove={() => handleRemoveHoliday(index)}
          />
        ))}
        <button
          className={styles.button}
          type="button"
          onClick={handleAddHoliday}
        >
          + {t("calendarHolidays.creation.addHoliday")}
        </button>
      </div>
    </div>
  );
}

export { Form };
